import { BWSBase } from "./bws-base";
export class Organization extends BWSBase {
    constructor(org) {
        super(org.created, org.createdBy, org.updated, org.updatedBy, false);
        this.name = org.name;
        this.nameLower = (org.name || "").toLowerCase().replaceAll(/[^A-Za-z0-9]/g, "");
        this.displayName = org.displayName;
        this.address = org.address;
        this.city = org.city;
        this.state = org.state;
        this.postalCode = org.postalCode;
        this.idNumber = org.idNumber;
        this.code = org.code;
        this.type = org.type;
        this.parent = org.parent;
        this.settings = org.settings;
        this.salesRep = org.salesRep;
        this.defaultContact = org.defaultContact;
        this.thumbnail_1200 = org.thumbnail_1200;
        this.thumbnail_200 = org.thumbnail_200;
        this.service_1200 = org.service_1200;
        this.service_200 = org.service_200;
        this.printUrl = org.printUrl;
        this.website = org.website;
        this.county = org.county;
        this.notesExist = org.notesExist; // optional, may not exist on all docs
        this.location = org.location;
        this.schoolCommissionRate = org.schoolCommissionRate;
        this.phone = org.phone;
        this.logos = org.logos || [];
    }
    static emptyOrg() {
        const org = { name: "", modified: false };
        return org;
    }
}
export const organizationConverter = {
    toFirestore: (organization) => {
        const data = {
            name: organization.name,
            nameLower: organization.name.toLowerCase().replaceAll(/[^A-Za-z0-9]/g, ""),
            displayName: organization.displayName || "",
            address: organization.address || "",
            city: organization.city || "",
            state: organization.state || "",
            postalCode: organization.postalCode || "",
            idNumber: organization.idNumber || "",
            code: organization.code || "",
            type: organization.type || "",
            thumbnail_1200: organization.thumbnail_1200 || "",
            thumbnail_200: organization.thumbnail_200 || "",
            service_1200: organization.service_1200 || "",
            service_200: organization.service_200 || "",
            printUrl: organization.printUrl || "",
            isPrivate: organization.isPrivate || false,
            schoolCommissionRate: organization.schoolCommissionRate || 0,
        };
        if (organization.parent)
            data.parent = organization.parent;
        if (organization.salesRep)
            data.salesRep = organization.salesRep;
        if (organization.defaultContact)
            data.defaultContact = organization.defaultContact;
        if (organization.county)
            data.county = organization.county;
        if (organization.website)
            data.website = organization.website;
        if (organization.phone)
            data.phone = organization.phone;
        if (organization.location)
            data.location = organization.location;
        if (organization.settings)
            data.settings = organization.settings;
        if (organization.logos)
            data.logos = organization.logos;
        return data;
    },
    fromFirestore: (orgSnapshot) => {
        const data = orgSnapshot.data();
        const orgSettings = {};
        if (data.settings) {
            if (data.settings.organizationId)
                orgSettings.organizationId = data.settings.id;
            else if (data.settings.id) {
                orgSettings.organizationId = data.settings.id;
            }
            if (data.settings.orderingCode)
                orgSettings.orderingCode = data.settings.orderingCode;
            if (data.settings.graduationRef)
                orgSettings.graduationRef = data.settings.graduationRef;
            if (data.settings.integrations)
                orgSettings.integrations = data.settings.integrations;
            if (data.settings.idcards) {
                orgSettings.idcards = data.settings.idcards;
            }
            if (data.settings.hideFromLookup) {
                orgSettings.idcards = data.settings.hideFromLookup;
            }
            if (data.settings.primaryColor)
                orgSettings.primaryColor = data.settings.primaryColor;
            if (data.settings.secondaryColor)
                orgSettings.secondaryColor = data.settings.secondaryColor;
        }
        const orgInterface = {
            name: data.name, displayName: data.displayName, address: data.address, city: data.city, state: data.state, postalCode: data.postalCode, idNumber: data.idNumber, type: data.type,
            parent: data.parent, settings: orgSettings, created: data.created, createdBy: data.createdBy, updated: data.updated, updatedBy: data.updatedBy,
            modified: false, salesRep: data.salesRep, defaultContact: data.defaultContact, thumbnail_1200: data.thumbnail_1200, thumbnail_200: data.thumbnail_200,
            service_1200: data.service_1200, service_200: data.service_200, printUrl: data.printUrl, notesExist: data.notesExist, code: data.code,
            location: data.location, schoolCommissionRate: data.schoolCommissionRate, website: data.website, phone: data.phone, county: data.county,
            logos: data.logos || []
        };
        const organization = new Organization(orgInterface);
        return organization;
    }
};
